export const SCAN_PAYLOAD_KEYS = ["cluster_id", "category_name", "product_name", "product_id"];

export const APP_CLIP_META_CONTENT = "app-id=6779742711, app-clip-bundle-id=com.balkans.io.SealSkinCovers.Clip, app-clip-display=card";

export const isScanLidarPath = (path) => typeof path === "string" && /\/scan-lidar\/?$/.test(path);

export const getClusterId = (product) => {
    if (product?.cluster != null && product.cluster !== "") {
        return String(product.cluster).replace(".", "");
    }

    const groupName = product?.parameter_group?.name;
    if (groupName) {
        const match = groupName.match(/(\d+)$/);
        if (match) {
            return match[1];
        }
    }

    return null;
};

export const compactScanPayload = (payload = {}) => {
    const compacted = {};

    SCAN_PAYLOAD_KEYS.forEach((key) => {
        const value = payload[key];
        if (value != null && value !== "") {
            compacted[key] = String(value);
        }
    });

    return compacted;
};

export const getScanPayload = (product) => ({
    cluster_id: getClusterId(product),
    category_name: product?.categories?.[product?.categories?.length - 1]?.slug,
    product_name: product?.title,
    product_id: product?.master_product_id,
});

export const getScanPayloadFromSearch = (search) => {
    const params = new URLSearchParams(search || "");
    const payload = {};

    SCAN_PAYLOAD_KEYS.forEach((key) => {
        payload[key] = params.get(key);
    });

    return compactScanPayload(payload);
};

export const buildScanLidarPath = (product) => {
    const handle = product?.handle;
    if (!handle) {
        return null;
    }

    const params = new URLSearchParams(compactScanPayload(getScanPayload(product)));
    const query = params.toString();

    return `/products/${handle}/scan-lidar${query ? `?${query}` : ""}`;
};
